import { render, staticRenderFns } from "./Wording.vue?vue&type=template&id=b121acec&"
import script from "./Wording.vue?vue&type=script&lang=js&"
export * from "./Wording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports